import { buttonBaseClasses, ButtonProps } from '@mui/material';
import Button from '@mui/material/Button';

export { buttonBaseClasses, type ButtonProps };

export default Button;
